module.exports = {
  Colors: {
    rgba: () => null
  },
  View: () => null,
  Text: () => null,
  Spacings: {},
  Button: () => null,
  Picker: () => null,
  Image: () => null,
  DateTimePicker: () => null,
  Checkbox: () => null,
  TextField: () => null,
  Typography: {},
  ExpandableOverlay: () => null,
  Incubator: {},
  Toast: () => null,
  mobileStyles: {},
  TouchableOpacity: () => null,
  StyleSheet: {
    create: (styles) => styles
  }
};
